export default __webpack_public_path__ + "92dc2007502737e9f99a9eda5b9405f5.png";